// Libraries
import _cloneDeep from 'lodash-es/cloneDeep';

// Afidium
import {SearchUtils} from "./SearchUtils";
import { IDateRange } from 'libraries/service/resources/model/search/IDateRange';
import { IProcessingSearchParameters } from '../resources/processings/IProcessingSearchParameters';

export interface IConfig {
    name: string;
    shortName: string;
}

export class ProcessingSearchParameters implements IProcessingSearchParameters {
    public static STRING_ARRAY_PROPERTIES: IConfig[] = [
        { name: 'status', shortName: 's' },
        { name: 'type', shortName: 't' },
    ];

    public static DATE_RANGE_PROPERTIES: IConfig[] = [
        { name: 'whenCreated', shortName: 'dc' },
    ];

    public status: string[];
    public type: string[];
    public whenCreated ?: IDateRange;

    public nbrecord: number;
    public first: number = 1;

    constructor() {
        this.nbrecord = 20;
    }

    public static fromRouteParams(routeParams: any): ProcessingSearchParameters{
        const newParams = new ProcessingSearchParameters();

        ProcessingSearchParameters.STRING_ARRAY_PROPERTIES.forEach((config) => {
            newParams[config.name] = SearchUtils.getStringArrayValue(routeParams, config.shortName);
        });

        ProcessingSearchParameters.DATE_RANGE_PROPERTIES.forEach((config) => {
            newParams[config.name] = SearchUtils.getDateRangeValue(routeParams, config.shortName);
        });

        newParams.nbrecord = routeParams.nbrecord || 20;
        newParams.first = routeParams.first || 1;

        return newParams;
    }

    public convertToUrlParameters(): any {
        let urlParameters: object = {};

        ProcessingSearchParameters.STRING_ARRAY_PROPERTIES.forEach((config) => {
            urlParameters = SearchUtils.setArrayValueIfNotEmpty(urlParameters, this[config.name], config.shortName);
        });

        ProcessingSearchParameters.DATE_RANGE_PROPERTIES.forEach((config) => {
            urlParameters = SearchUtils.setDateRangeValueIfNotEmpty(urlParameters, this[config.name], config.shortName);
        });

        urlParameters = SearchUtils.setValueIfNotEmpty(urlParameters, this.nbrecord, 'nbrecord');
        urlParameters = this.first === 0 ?
            urlParameters : SearchUtils.setValueIfNotEmpty(urlParameters, this.first, 'first');

        return urlParameters;
    }

    public clone(): ProcessingSearchParameters {
        return _cloneDeep(this);
    }

    public clearValues(names: string[]): this{
        names.forEach((name) => {
            this[name] = undefined;
        });

        return this;
    }
}


